export const SUIVI_FACTURES_AVANT_ECHEANCE = {
    SET_SCROLL: 'SET_SUIVI_FACTURES_AVANT_ECHEANCE_SCROLL_POSITION',
    SET_ITEMS_AVANT_ECHEANCE: 'SET_SUIVI_FACTURES_AVANT_ECHEANCE_ITEMS',
    ADD_ITEMS: 'ADD_SUIVI_FACTURES_AVANT_ECHEANCE_ITEMS',
    RESET_ITEMS: 'RESET_SUIVI_FACTURES_AVANT_ECHEANCE_ITEMS',

    SET_PAGE_AVANT_ECHEANCE: 'SET_SUIVI_FACTURES_AVANT_ECHEANCE_PAGE',
    SET_NB_OF_PAGES_AVANT_ECHEANCE: 'SET_SUIVI_FACTURES_AVANT_ECHEANCE_NB_OF_PAGES',
    SET_SCROLL_AVANT_ECHEANCE: 'SET_SUIVI_FACTURES_AVANT_ECHEANCE_SCROLL',
    SET_COUNT_AVANT_ECHEANCE: 'SET_SUIVI_FACTURES_AVANT_ECHEANCE_COUNT',

    SET_SORT_AVANT_ECHEANCE: 'SET_DEMANDE_FACTURES_AVANT_ECHEANCE_SORT',

    SET_IS_LOADING_AVANT_ECHEANCE: 'SET_SUIVI_FACTURES_AVANT_ECHEANCE_IS_LOADING',
    SET_ERROR_AVANT_ECHEANCE: 'SET_SUIVI_FACTURES_AVANT_ECHEANCE_ERROR',
    SET_SUCCESS_AVANT_ECHEANCE: 'SET_SUIVI_FACTURES_AVANT_ECHEANCE_SUCCESS',

};
